export const textOrDash = (value, fallback = '-') => {
  if (value === null || value === undefined) return fallback;
  const text = String(value).trim();
  if (!text || text.toLowerCase() === 'undefined' || text.toLowerCase() === 'null') return fallback;
  return text;
};

export const safeLabel = (t, key, fallback) => {
  const value = t(key);
  return textOrDash(value, fallback) === key ? fallback : textOrDash(value, fallback);
};

export const userFullName = (user) => {
  const firstName = textOrDash(user && user.firstName, '');
  const lastName = textOrDash(user && user.lastName, '');
  return textOrDash(`${firstName} ${lastName}`.trim(), 'Utilisateur');
};
